<template>
    <el-dropdown trigger="click">
        <a href="javascript:;" class="btn-icon"><i class="icon-burger"></i></a>
        <el-dropdown-menu slot="dropdown">
            <el-dropdown-item v-for="(action, index) in actions" :key="index" :disabled="!hasAccess(action.permission, permissions)" :class="!hasAccess(action.permission, permissions) ? 'link-disabled' : ''">
                <el-dropdown v-if="action.childrens && action.childrens.length > 0" placement="right-start" class="wp-10">
                    <el-dropdown-item class="p-0 gray-100">{{action.label}}</el-dropdown-item>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item v-for="(children, childIndex) in action.childrens" :key="childIndex">
                            <a v-if="children.type == 'vuejs'" @click="$emit('clicked', children.value)" :class="!hasAccess(children.permission, permissions) ? 'link-disabled' : ''">
                                {{children.label}}
                            </a>
                            <a v-else :href="children.value" :class="!hasAccess(children.permission, permissions) ? 'link-disabled' : ''">
                                {{children.label}}
                            </a>
                        </el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
                <div v-else>
                    <a v-if="action.type == 'vuejs'" @click="$emit('clicked', action.value)" :class="!hasAccess(action.permission, permissions) ? 'link-disabled' : ''">
                        {{action.label}}
                    </a>
                    <a v-else :href="action.value" :class="!hasAccess(action.permission, permissions) ? 'link-disabled' : ''">
                        {{action.label}}
                    </a>
                </div>
            </el-dropdown-item>
        </el-dropdown-menu>
    </el-dropdown>
</template>

<script>
    import { hasAccess } from '../../helpers'
    export default {
        props: {
            actions: {
                type: Array,
                required: true
            },
            permissions: {
                type: Object,
                required: false,
                default: () => {}
            }
        },
        data(){
            return {
            }
        },
        methods:{
            hasAccess
        }
    }
</script>

<style scoped>

</style>